export const ADVISER_LOGO_FUNCTIONS = {
  LOGIN: 'login',
  MENU: 'menu',
  PDF: 'pdf',
  LAZY_PACK: 'lazy-pack',
  ACCOUNT: 'account',
  PROFILE_PLUS: 'profile-plus'
};
